<template>
  <v-form ref="generalSettingsForm" v-model="valid">
    <v-container fluid grid-list-md>
      <pensions-plan-information
        v-if="planType === 'Pension'"
        :generalSettings="generalSettings"
        :disabled="disabled"
        @valid="valid = $event"
        @load-unique-identifiers="$emit('load-unique-identifiers')"
        :uniqueIdentifiers="uniqueIdentifiers"
      />
      <plan-information
        v-else
        :generalSettings="generalSettings"
        :disabled="disabled"
        @load-unique-identifiers="$emit('load-unique-identifiers')"
        :uniqueIdentifiers="uniqueIdentifiers"
      />
      <plan-settings
        v-if="planType === 'HW'"
        :generalSettings="generalSettings"
        @valid="validCheckboxes = $event"
        @has-classes="$emit('has-classes', $event)"
        @has-occupations="$emit('has-occupations', $event)"
        @has-eligibility="$emit('has-eligibility', $event)"
        @update-classes="$emit('update-classes', $event)"
        @update-occupations="$emit('update-occupations', $event)"
        @has-beneficiaries="$emit('has-beneficiaries', $event)"
        :disabled="disabled"
        @trust-fund="$emit('trust-fund', $event)"
        @beneficiary-statement-on-trustfund="
          $emit('beneficiary-statement-on-trustfund', $event)
        "
      />
      <pensions-plan-settings
        v-else-if="planType === 'Pension'"
        :generalSettings="generalSettings"
        @valid="validCheckboxes = $event"
        @has-classes="$emit('has-classes', $event)"
        @has-occupations="$emit('has-occupations', $event)"
        @update-classes="$emit('update-classes', $event)"
        @update-occupations="$emit('update-occupations', $event)"
        :disabled="disabled"
        @trust-fund="$emit('trust-fund', $event)"
        @update-coverage="$emit('update-coverage', [$event])"
        :organizationId="organizationId"
        :draftId="draftId"
        :coverages="coverages"
      />
      <no-managed-plan-settings
        v-else
        :generalSettings="generalSettings"
        @valid="validCheckboxes = $event"
        :disabled="disabled"
        :organizationId="organizationId"
        :draftId="draftId"
      />
      <calculation-term-configuration
        v-if="planType === 'HW'"
        :generalSettings="generalSettings"
        :disabled="disabled"
      />
    </v-container>
  </v-form>
</template>

<script>
import PlanInformation from "@/components/PlanBuilder/PlanInformation.vue";
import PlanSettings from "@/components/PlanBuilder/PlanSettings.vue";
import CalculationTermConfiguration from "@/components/PlanBuilder/CalculationTermConfiguration.vue";
import PensionsPlanInformation from "./PensionsPlanInformation.vue";
import PensionsPlanSettings from "@/components/PlanBuilder/PensionsPlanSettings.vue";
import NoManagedPlanSettings from "@/components/PlanBuilder/NoManagedPlanSettings.vue";

export default {
  components: {
    PlanInformation,
    PlanSettings,
    CalculationTermConfiguration,
    PensionsPlanInformation,
    PensionsPlanSettings,
    NoManagedPlanSettings
  },
  props: {
    generalSettings: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: Boolean,
    planType: String,
    draftId: String,
    organizationId: String,
    coverages: {
      type: Array,
      default() {
        return [];
      },
    },
    uniqueIdentifiers: Array,
  },
  data() {
    return {
      valid: false,
      validCheckboxes: false,
    };
  },
  watch: {
    valid: {
      handler(v) {
        console.log("gs valid: ", v, this.planType);
        if (this.planType === "HW") {
          this.$emit("valid", v && this.validCheckboxes);
        } else {
          this.$emit("valid", v);
        }
      },
    },
    validCheckboxes: {
      handler(v) {
        this.$emit("valid", v && this.valid);
      },
    },
  },
};
</script>
